var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommunities = function SvgCommunities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M12.313 3.913c.808-1.28 1.212-1.92 1.742-2.113a1.65 1.65 0 0 1 1.129 0c.53.192.934.833 1.742 2.113.91 1.442 1.365 2.163 1.285 2.757-.055.408-.26.781-.576 1.045-.46.386-1.312.386-3.016.386s-2.556 0-3.015-.386a1.65 1.65 0 0 1-.576-1.045c-.08-.594.375-1.315 1.285-2.757ZM2.702 4.9c0-1.333 0-2 .34-2.467q.166-.228.393-.393c.467-.34 1.134-.34 2.467-.34s2 0 2.468.34q.226.166.393.393c.34.467.34 1.134.34 2.467s0 2-.34 2.468q-.166.227-.393.393c-.468.34-1.134.34-2.468.34-1.333 0-2 0-2.467-.34a1.8 1.8 0 0 1-.394-.393c-.34-.468-.34-1.134-.34-2.468Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.229,
    d: "M3.68 12.679c.892-.892 1.338-1.338 1.878-1.423q.263-.042.526 0c.54.085.985.531 1.877 1.423.892.891 1.338 1.337 1.423 1.877q.042.263 0 .526c-.085.54-.531.986-1.423 1.877-.892.892-1.337 1.338-1.877 1.424a1.7 1.7 0 0 1-.526 0c-.54-.086-.986-.532-1.878-1.424s-1.337-1.337-1.423-1.877a1.7 1.7 0 0 1 0-.526c.086-.54.532-.985 1.423-1.877Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.259,
    cy: 14.502,
    r: 3.2,
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })));
};
export default SvgCommunities;